import KONIG_EXT_1 from "./KONIG_EXT_1";
export default {
  KONIG_EXT_1,
};
